import { Vehicle } from '../core/Vehicle';
import * as THREE from 'three';

export class GarbageTruck extends Vehicle {
  constructor() {
    super();
    this.maxSpeed = 8; // Slower than car
    this.acceleration = 0.1;
    this.createModel();
  }

  public createModel(): void {
    // Bus body
    const body = new THREE.Mesh(
      new THREE.BoxGeometry(2.5, 2.5, 7),
      new THREE.MeshPhongMaterial({ color: 0x4287f5 })
    );

    // Windows
    const windows = new THREE.Mesh(
      new THREE.BoxGeometry(2.4, 1, 6.8),
      new THREE.MeshPhongMaterial({ color: 0x88c1ff })
    );
    windows.position.y = 0.5;

    this.mesh.add(body);
    this.mesh.add(windows);
  }
}